<script>
// import countTo from "vue-count-to";
/**
 * Sales-analytics component
 */
 import CoinChart from "@/components/CoinChart.vue";
export default {
    components: {
        // countTo
        CoinChart
    },
    data() {
        return {
            series: [
                {
                    name: 'Volume',
                    type: 'area',
                    data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
                }, 
            ],
            chartOptions: {
                chart: {
                    stacked: false,
                    toolbar: {
                        show: false
                    }
                },
                stroke: {
                    width: [0, 2, 4],
                    curve: 'smooth'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '30%'
                    }
                },
                colors: ['#5b73e8', '#dfe2e6', '#f1b44c'],
                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003', '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'],
                markers: {
                    size: 0
                },

                xaxis: {
                    type: 'datetime'
                },
                yaxis: {
                    title: {
                        text: 'Points',
                    },
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0) + " points";
                            }
                            return y;

                        }
                    }
                },
                grid: {
                    borderColor: '#f1f1f1'
                }
            }
        };
    }
};
</script>

<template>
<div class="col-12">
    <div class="card">
        <div class="card-body">
            <div class="float-end">
                <b-dropdown variant="white" toggle-class="text-reset p-0" menu-class="dropdown-menu-end">
                    <template v-slot:button-content>
                        <span class="fw-semibold">Sort By:</span>
                        <span class="text-muted">
                            Weekly
                            <i class="mdi mdi-chevron-down ms-1"></i>
                        </span>
                    </template>
                    <a class="dropdown-item" href="#">Weekly</a>
                </b-dropdown>
            </div>
            <h4 class="card-title mb-4">Chart (Last 7 days)</h4>

            <div class="mt-1">
            </div>

            <div class="mt-3">
                <CoinChart 
                    token="fatcake"
                    label="FatCake Price"
                    color="#e91e63"
                    backgroundColor="rgba(233, 30, 99, 0.2)"
                />
            </div>
        </div>
        <!-- end card-body-->
    </div>
    <div class="card">
        <div class="card-body">
            <div class="float-end">
                <b-dropdown variant="white" toggle-class="text-reset p-0" menu-class="dropdown-menu-end">
                    <template v-slot:button-content>
                        <span class="fw-semibold">Sort By:</span>
                        <span class="text-muted">
                            Weekly
                            <i class="mdi mdi-chevron-down ms-1"></i>
                        </span>
                    </template>
                    <a class="dropdown-item" href="#">Weekly</a>
                </b-dropdown>
            </div>
            <h4 class="card-title mb-4">Chart (Last 7 days)</h4>

            <div class="mt-1">
            </div>

            <div class="mt-3">
                <CoinChart 
                    token="binancecoin"
                    label="BNB Price"
                    color="yellow"
                    backgroundColor="rgba(255,255,0, 0.2)"
                />
            </div>
        </div>
        <!-- end card-body-->
    </div>
    <!-- end card-->
    <div class="card">
        <div class="card-body">
            <div class="float-end">
                <b-dropdown variant="white" toggle-class="text-reset p-0" menu-class="dropdown-menu-end">
                    <template v-slot:button-content>
                        <span class="fw-semibold">Sort By:</span>
                        <span class="text-muted">
                            Weekly
                            <i class="mdi mdi-chevron-down ms-1"></i>
                        </span>
                    </template>
                    <a class="dropdown-item" href="#">Weekly</a>
                </b-dropdown>
            </div>
            <h4 class="card-title mb-4">Chart (Last 7 days)</h4>

            <div class="mt-1">
            </div>

            <div class="mt-3">
                <CoinChart 
                    token="pancakeswap-token"
                    label="CAKE Price"
                    color="pink"
                    backgroundColor="rgba(255,192,203, 0.2)"
                />
            </div>
        </div>
        <!-- end card-body-->
    </div>
</div>
<!-- end col-->
</template>
